export const animations = {
  longDuration: '0.5s',
  standardDuration: '0.3s',
  shortDuration: '0.1s',
};
